import React, { useState } from 'react';
import api from '../../api';
import { toast } from 'react-toastify';
import { MapPinIcon, ArrowCounterClockwiseIcon, PencilSimpleIcon } from '@phosphor-icons/react';
import EditFacilityModal from '../../components/Modal/EditFacilityModal';

const TOAST_OPTIONS = {
    position: 'top-center',
    autoClose: 300,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const CustomerInfo = ({ customerId, facilities, onSuccess }) => {
    const [editingFacility, setEditingFacility] = useState(null);

    const runGeocoding = async facilityId => {
        try {
            await api.geocode_facility(facilityId);
            toast.success('Geocoding successful!', TOAST_OPTIONS);
            onSuccess();
        } catch (error) {
            console.error('Error during geocoding:', error);
            toast.error('Geocoding failed, please try again.', TOAST_OPTIONS);
        }
    };

    return (
        <div className="card-wrapper customer-details--header">
            <div className="customer-details__card-header">Customer Information</div>
            <div className="customer-details__customer-info">
                <p className="customer-details__customer">
                    Customer:
                    <span className="customer-details__customer-number"> {customerId}</span>
                </p>

                <div>
                    {facilities.map((facility, index) => (
                        <div key={facility.facility_id}>
                            {index > 0 && <div className="customer-details__facility-divider" />}
                            <div className="customer-details__facility-item">
                                <MapPinIcon className="customer-details__facility-icon" />
                                <div className="customer-details__facility-content">
                                    <div className="customer-details__facility-address-row">
                                        <p className="customer-details__facility-address">{facility.address || facility.facility_id}</p>
                                        <button className="customer-details__facility-edit-btn" onClick={() => setEditingFacility(facility)}>
                                            <PencilSimpleIcon className="customer-details__facility-edit-icon" size={16} />
                                        </button>
                                    </div>
                                    {(facility.retailer_customer_id || facility.retailer_facility_id) && (
                                        <div className="customer-details__facility-ids">
                                            {facility.retailer_customer_id && (
                                                <span className="customer-details__facility-id">
                                                    <span className="customer-details__facility-id-label">Customer number</span>
                                                    {facility.retailer_customer_id}
                                                </span>
                                            )}
                                            {facility.retailer_facility_id && (
                                                <span className="customer-details__facility-id">
                                                    <span className="customer-details__facility-id-label">Facility number</span>
                                                    {facility.retailer_facility_id}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    <div className="customer-details__facility-geocode">
                                        <span className="customer-details__facility-geocode-text">Coordinates not correct?</span>
                                        <button className="customer-details__facility-geocode-btn" onClick={() => runGeocoding(facility.facility_id)}>
                                            <ArrowCounterClockwiseIcon className="customer-details__facility-geocode-icon" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {editingFacility && (
                <EditFacilityModal
                    facility={editingFacility}
                    open={!!editingFacility}
                    setOpen={val => {
                        if (!val) {
                            setEditingFacility(null);
                        }
                    }}
                    onSuccess={() => {
                        setEditingFacility(null);
                        onSuccess();
                    }}
                />
            )}
        </div>
    );
};

export default CustomerInfo;
